import { defineMessages } from 'react-intl';

import { intlService } from '~/i18n/IntlService';
import { TicketState } from '~/redux/api/types/k2/tickets';

const messages = defineMessages({
  active: {
    id: 'workflowCLMEvolutionTickets.stateActive',
    defaultMessage: 'Active',
    description: 'Active state of the ticket',
  },
  paused: {
    id: 'workflowCLMEvolutionTickets.statePaused',
    defaultMessage: 'Paused',
    description: 'Paused state of the ticket',
  },
  cancelled: {
    id: 'workflowCLMEvolutionTickets.stateCancelled',
    defaultMessage: 'Canceled',
    description: 'Canceled state of the ticket',
  },
  completed: {
    id: 'workflowCLMEvolutionTickets.stateCompleted',
    defaultMessage: 'Completed',
    description: 'Completed state of the ticket',
  },
});

export const getTicketStateLabel = (state: TicketState) => {
  const intl = intlService.getIntl();

  const ticketStateLabelMap: Record<TicketState, string> = {
    ACTIVE: intl.formatMessage(messages.active),
    PAUSED: intl.formatMessage(messages.paused),
    CANCELLED: intl.formatMessage(messages.cancelled),
    COMPLETED: intl.formatMessage(messages.completed),
  };
  return ticketStateLabelMap[state];
};
